import { createEvent, createStore } from 'effector';

export const spinnerIncrease = createEvent();
export const spinnerDecrease = createEvent();
export const $spinnerCounter = createStore(0)
  .on(spinnerIncrease, (v) => v + 1)
  .on(spinnerDecrease, (v) => Math.max(v - 1, 0));
